import React from "react"
import Home from '../pages/home';

const IndexPage = () => (
  <Home />
)

export default IndexPage
